<template>
  <div class="mind">
    <div class="title">
      <div class="title">课程管理</div>
      <el-form
        :inline="true"
        label-width="80px"
        :model="searchForm"
        label-position="top"
        size="small"
        ref="myForm"
      >
        <el-row>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="视频ID/标题">
              <el-input v-model="searchForm.title"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="课程属性">
              <el-select
                v-model="searchForm.attribute"
                multiple
                collapse-tags
                placeholder="请选择"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in attributeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="类目">
              <el-cascader
                v-model="searchForm.catePaths"
                :options="cateTree"
                :props="cascaderPropsMultiple"
                clearable
                collapse-tags
                placeholder="请选择"
                style="width: 310px"
              >
              </el-cascader>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="推荐位">
              <el-select
                v-model="searchForm.posid"
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in posidList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="上下架状态">
              <el-select
                v-model="searchForm.status"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="新增时间">
              <dataPicker
                style="width: 310px"
                :datevalue.sync="searchForm.time_add"
                :clearFlag="searchForm.time_update.length"
              ></dataPicker>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label="修改时间">
              <dataPicker
                style="width: 310px"
                :datevalue.sync="searchForm.time_update"
                :clearFlag="searchForm.time_add.length"
              ></dataPicker>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :xl="6" :md="12" :xs="24">
            <el-form-item label=" ">
              <el-button
                icon="el-icon-refresh"
                size="medium"
                @click="clearForm"
              >
                清除条件
              </el-button>
              <el-button
                type="goon"
                icon="el-icon-search"
                size="medium"
                @click="searchList"
              >
                搜索
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="cotent_table">
      <el-table
        class="boder_table"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChang"
        :default-sort="defaultSort"
        v-loading="tableData.loading"
      >
        <el-table-column type="selection" width="55" align="center">
        </el-table-column>
        <el-table-column prop="id" label="id" align="center" width="55">
        </el-table-column>
        <el-table-column
          prop="course_cover_url"
          label="视频封面"
          width="110"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 106px; height: 53px"
              :src="imgUrl + scope.row.course_cover_url"
              :previewSrcList="imgUrlList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column pimgU label="视频" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="goPreview(scope.row)"
              >预览</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="title"
          label="视频标题"
          align="center"
          width="120"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column prop="attribute" label="课程属性" align="center">
        </el-table-column>
        <el-table-column prop="cate" label="类目" align="center">
        </el-table-column>
        <el-table-column prop="posid" label="推荐位" align="center" width="150">
          <template slot-scope="scope">
            {{ scope.row.posid === "0" ? "" : scope.row.posid }}
          </template>
        </el-table-column>
        <el-table-column
          prop="course_uv"
          label="学习人数"
          align="center"
          sortable
          width="100"
        ></el-table-column>
        <el-table-column
          prop="course_pv"
          label="学习人次"
          align="center"
          sortable
          width="100"
        ></el-table-column>
        <el-table-column prop="" label="状态" align="center">
          <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.status == 0">下架</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">上架</el-tag>
            <el-tag type="warning" v-if="scope.row.status == 3">上架中</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="time_add"
          label="新增时间"
          align="center"
          width="150"
          sortable
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="time_update"
          label="修改时间"
          align="center"
          width="150"
          :show-overflow-tooltip="true"
          sortable
        ></el-table-column>
        <el-table-column prop="remark" label="备注" align="center">
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="editData(scope.row)">编辑</el-button>
            <el-button
              type="text"
              v-if="
                tabelStatusList.length &&
                tabelStatusList[scope.$index].status == 0
              "
              @click="putaway(scope.row)"
              >上架</el-button
            >
            <el-button
              type="text"
              v-if="
                tabelStatusList.length &&
                tabelStatusList[scope.$index].status == '1'
              "
              @click="shelve(scope.row)"
              style="color: #f56c6c !important"
              >下架</el-button
            >
            <el-button type="text" @click="delOnlyOne(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="table_foot">
        <!-- 按钮组 -->
        <div>
          <el-button
            size="small"
            type="goon"
            icon="el-icon-plus"
            @click="addCourse"
            >新增</el-button
          >
          <el-button
            size="small"
            icon="el-icon-delete"
            type="danger"
            @click="delLists"
            :disabled="!tableIds.length"
            >删除
          </el-button>
          <el-button
            size="small"
            icon="el-icon-shopping-cart-2"
            @click="putaway('list')"
            :disabled="!tableIds.length"
          >
            上架</el-button
          >
          <el-button
            size="small"
            icon="el-icon-shopping-cart-2"
            @click="shelve('list')"
            :disabled="!tableIds.length"
            >下架
          </el-button>
          <el-button
            size="small"
            icon="el-icon-box"
            :disabled="!tableIds.length"
            @click="changeDialog"
            >分类</el-button
          >
        </div>
        <!-- 分页器 -->
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableOpt.page"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="课程分类"
      width="600px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="onDialog"
    >
      <div style="text-align: center">
        <el-form
          label-width="80px"
          ref="course_from"
          :model="courseFrom"
          style="display: inline-block"
          :rules="rules"
        >
          <el-form-item label="类别" prop="cate">
            <el-cascader
              v-model="courseFrom.catePaths"
              :options="cateTree"
              :props="cascaderProps"
              clearable
              collapse-tags
              placeholder="请选择"
              style="width: 310px"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="推荐位" prop="posid">
            <el-select v-model="courseFrom.posid" placeholder="请选择" :clearable="true">
              <el-option
                v-for="item in posidList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onDialog">取 消</el-button>
        <el-button type="goon" @click="submitCourse">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :visible.sync="goAddData"
      title="新增选择"
      top="35vh"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="add_btns">
        <el-button @click="goOnly" class="only_course">单节课</el-button>
        <el-button @click="goMost" class="many_course">系列课</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import FilterLayout from "@/layout/form";
export default {
  components: {
    FilterLayout,
  },
  data() {
    return {
      imgUrl: "",
      time: 0,
      statusListTimer: null,
      tabelStatusList: [],
      defaultSort: {},
      dialogVisible: false,
      goAddData: false,
      tableIds: [],
      searchForm: {
        title: "",
        attribute: [],
        cate: [],
        catePaths: [],
        posid: [],
        status: [],
        time_add: [
        ],
        time_update: [],
      },
      courseFrom: {
        cate: "1",
        posid: "",
      },
      tableData: {
        data: [],
        total: 0,
        page: 1,
        page_size: 10,
        loading: false,
      },
      tableOpt: {
        page: 1,
        page_size: 10,
      },
      attributeList: [
        {
          value: "1",
          label: "单节课",
        },
        {
          value: "2",
          label: "系列课",
        },
      ],
      cateList: [],
      cateTree: [],
      cascaderProps: { value: 'id', label: 'cate_name', children: 'children' },
      cascaderPropsMultiple: { value: 'id', label: 'cate_name', children: 'children',multiple:true },
      posidList: [
        {
          value: "1",
          label: "精品位",
        },
      ],
      statusList: [
        {
          value: "1",
          label: "上架",
        },
        {
          value: "3",
          label: "上架中",
        },
        {
          value: "0",
          label: "下架",
        },
      ],
      imgUrlList: [],
      tableStatus: [],
      rules: {
        cate: [
          { required: true, message: "请上传视频资源", trigger: "change" },
        ],
      },
    };
  },
  watch: {
    time(val) {
      if (val != 0 && val % 60 == 0) {
        this.getStatusList();
      }
    },
  },
  beforeDestroy() {this.handleCurrentChange
    clearInterval(this.statusListTimer);
  },
  mounted() {
    this.imgUrl = process.env.VUE_APP_URL;
    this.loadCateList();
    this.loadCateTree();
    this.getList();
    this.getStatusList();
    this.statusListTimer = setInterval(() => {
      this.time++;
    }, 1000);
  },
  methods: {
    async getList() {
      this.tableData.loading = true;
      const { searchForm, tableOpt, defaultSort } = this;
      // 将级联选中的路径数组转换为后端需要的二级类目ID数组
      const cate = Array.isArray(searchForm.catePaths) && searchForm.catePaths.length
        ? searchForm.catePaths
            .map(path => Array.isArray(path) ? path[1] : undefined)
            .filter(Boolean)
        : searchForm.cate;
      const [err, res] = await this.$http.post("course/list", {
        ...searchForm,
        cate,
        ...tableOpt,
        order: defaultSort.order,
        prop: defaultSort.prop,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { list, page, page_size, total } = res;
      this.tableData.loading = false;
      this.tableData.data = list ? list : [];
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
      this.imgUrlList = list.map((item) => {
        return this.imgUrl + item.course_cover_url;
      });
    },
    async loadCateList() {
      const [err, res] = await this.$http.get("home/course/cate");
      if (err) return;
      const data = (res.list || res || [])
        .slice()
        .sort((a, b) => a.id - b.id)
        .reduce((acc, category) => {
          const children = Array.isArray(category.children)
            ? category.children.filter(child => !child.links_src)
            : [];
          children.forEach(child => {
            acc.push({ value: String(child.id), label: child.cate_name });
          });
          return acc;
        }, []);
      this.cateList = data;
    },
    async loadCateTree() {
      const [err, res] = await this.$http.get("home/course/cate");
      if (err) return;
      const tree = (res.list || res || [])
        .slice()
        .sort((a, b) => a.id - b.id)
        .map(category => ({
          ...category,
          children: Array.isArray(category.children)
            ? category.children.filter(child => !child.links_src)
            : []
        }));
      this.cateTree = tree;
    },
    async searchList() {
      this.tableData.loading = true;
      const { searchForm, tableOpt, defaultSort } = this;
      const cate = Array.isArray(searchForm.catePaths) && searchForm.catePaths.length
        ? searchForm.catePaths
            .map(path => Array.isArray(path) ? path[1] : undefined)
            .filter(Boolean)
        : searchForm.cate;
      const [err, res] = await this.$http.post("course/list", {
        ...searchForm,
        cate,
        order: defaultSort.order,
        prop: defaultSort.prop,
        page: 1,
        page_size: 10,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { list, page, page_size, total } = res;
      this.tableData.loading = false;
      this.tableData.data = list ? list : [];
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
      this.imgUrlList = list.map((item) => {
        return this.imgUrl + item.course_cover_url;
      });
      this.getStatusList();
    },
    async getStatusList() {
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("course/status", {
        ...searchForm,
        ...tableOpt,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { list } = res;
      this.tabelStatusList = list ? list : [];
    },
    handleSelectionChange(data) {
      if (data.length) {
        this.tableIds = data.map((item) => {
          return item.id;
        });
        this.tableStatus = data.map((item) => {
          return item.status;
        });
      } else {
        this.tableIds = [];
        this.tableStatus = [];
      }
    },
    handleSizeChange(data) {
      console.log(data);
      this.getStatusList();
      this.getList();
    },
    handleCurrentChange(data) {
      this.tableData.page = data;
      this.tableOpt.page = data;
      this.getStatusList();
      this.getList();
    },
    async handleSortChang(column) {
      this.defaultSort = {
        order: column.order,
        prop: column.prop,
      };
      console.log(column);
      console.log(this.defaultSort);
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("course/list", {
        ...searchForm,
        ...tableOpt,
        order: column.order,
        prop: column.prop,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      console.log(1);
      const { list, page, page_size, total } = res;
      this.tableData.loading = false;
      this.tableData.data = list;
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
      this.imgUrlList = list.map((item) => {
        return this.imgUrl + item.course_cover_url;
      });
    },
    // 删除一个
    delOnlyOne(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: "确定删除该视频？",
        message: h("p", null, [h("span", null, "操作不可逆，谨慎操作 ")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "del_message_btn",
      }).then(async (action) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("course/del", {
          id: [data.id],
        });
        if (err) {
          this.tableData.loading = false;
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getStatusList();
        this.getList();
      });
    },
    // 删除多个
    delLists(data) {
      if (this.tableIds.length === 0) {
        this.$message.error("请勾选课程");
        return;
      }
      let tableIds = this.tableIds;
      const h = this.$createElement;
      this.$msgbox({
        title: "确定删除所选视频？",
        message: h("p", null, [h("span", null, "操作不可逆，谨慎操作 ")]),
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "del_message_btn",
      }).then(async (action) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("course/del", {
          id: tableIds,
        });
        if (err) {
          this.tableData.loading = false;
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });
        this.getStatusList();
        this.getList();
      });
    },
    // 上架
    putaway(data) {
      let tableIds = this.tableIds;
      if (data != "list") {
        tableIds = data.id;
      } else {
        if (this.tableStatus.indexOf("1") !== -1) {
          this.$message.error("所选内容已包含上架课程");
          return;
        }
        if (this.tableIds.length === 0) {
          this.$message.error("请勾选课程");
          return;
        }
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "确定上架所选视频？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "del_message_btn",
      }).then(async (action) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("course/shelves", {
          id: tableIds,
          operation: "up",
        });
        if (err) {
          this.tableData.loading = false;
          return;
        }
        this.$message({
          message: "上架成功",
          type: "success",
        });
        this.getStatusList();
        this.getList();
      });
    },
    // 上架
    shelve(data) {
      let tableIds = this.tableIds;
      if (data != "list") {
        tableIds = data.id;
      } else {
        if (this.tableStatus.indexOf("0") !== -1) {
          this.$message.error("所选内容已包含下架课程");
          return;
        }
        if (this.tableIds.length === 0) {
          this.$message.error("请勾选课程");
          return;
        }
      }
      const h = this.$createElement;
      this.$msgbox({
        title: "确定下架所选视频？",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        confirmButtonClass: "del_message_btn",
      }).then(async (action) => {
        this.tableData.loading = true;
        const [err, res] = await this.$http.post("course/shelves", {
          id: tableIds,
          operation: "down",
        });
        if (err) {
          this.tableData.loading = false;
          return;
        }
        this.$message({
          message: "下架成功",
          type: "success",
        });
        this.getStatusList();
        this.getList();
      });
    },
    changeDialog() {
      if (this.tableIds.length === 0) {
        this.$message.error("请勾选课程");
        return;
      }
      this.dialogVisible = true;
    },
    // 类型
    async submitCourse() {
      const { courseFrom } = this;
      // 未选择“类别”时不允许提交
      if (!Array.isArray(courseFrom.catePaths) || courseFrom.catePaths.length === 0) {
        this.$message.error('请选择类别')
        return
      }
      const cate = Array.isArray(courseFrom.catePaths) && courseFrom.catePaths.length
        ? courseFrom.catePaths[1]
        : courseFrom.cate;
      const [err, res] = await this.$http.post("course/edit_cate", {
        ...courseFrom,
        cate,
        id: this.tableIds,
      });
      if (err) {
        return;
      }
      this.$message({
        message: "分类成功",
        type: "success",
      });
      this.$nextTick(() => {
        this.courseFrom.cate = "1";
        this.courseFrom.catePaths = [];
        this.courseFrom.posid = "";
      });
      this.dialogVisible = false;
      this.getList();
    },
    onDialog() {
      this.$nextTick(() => {
        this.courseFrom.cate = "1";
        this.courseFrom.catePaths = [];
        this.courseFrom.posid = "";
      });
      this.dialogVisible = false;
    },
    // 新增
    addCourse() {
      this.goAddData = true;
    },
    // 编辑
    editData(data) {
      if (data.attribute === "单节课") {
        this.$router.push({
          path: "/manage_center/course_management/add",
          query: {
            id: data.id,
            status: data.status,
          },
        });
      } else {
        this.$router.push({
          path: "/manage_center/course_management/mostAdd",
          query: {
            id: data.id,
            status: data.status,
          },
        });
      }
    },
    goOnly() {
      this.$router.push("/manage_center/course_management/add");
    },
    goMost() {
      this.$router.push("/manage_center/course_management/mostAdd");
    },
    goPreview(item) {
      // 新开页面
      // let routeData = this.$router.resolve({
      //   path: "/count_center/player",
      //   query: {
      //     id: item.id,
      //     type: 2,
      //   },
      // });
      let routeData = this.$router.resolve({
        path: `/count_center/player/${item.id}/2`,
      });
      window.open(routeData.href, "_blank");
    },
    // 清除
    clearForm() {
      this.searchForm = {
        title: "",
        attribute: [],
        cate: [],
        catePaths: [],
        posid: [],
        status: [],
      };
      this.searchForm.time_add = [
        moment().subtract(30, "d").format("YYYY-MM-DD"),
        moment().subtract(0, "d").format("YYYY-MM-DD"),
      ];
      this.searchForm.time_update = [];
      console.log(this.searchForm);
      this.$refs.myForm.resetFields();
      this.$refs.multipleTable.clearSort();
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.add_btns {
  display: flex;
  justify-content: center;
}

.mind {
  .title {
    background: #fff;
    padding: 16px;

    .title {
      padding: 0 0 32px 0;
      font-size: 16px;
      color: #23262f;
      font-weight: 600;
    }
  }

  /deep/.el-input--small .el-input__inner {
    width: 310px;
  }

  /deep/.el-form-item__label {
    min-height: 42px;
    min-width: 50px;
  }

  .el-button--goon,
  .el-button--goon:focus,
  .el-button--goon.is-active,
  .el-button--goon:active {
    background: #2ab18b;
    border-color: #2ab18b;
    color: #fff;
  }

  .el-button--goon:hover {
    background: #8cd8da;
    border-color: #8cd8da;
    color: #fff;
  }

  .el-button--goon:focus {
    background: #0a8965;
    border-color: #0a8965;
    color: #fff;
  }

  .cotent_table {
    background: #fff;
    margin-top: 16px;
    padding: 20px;

    /* .el-button--text {
      color: #2ab18b !important;
    } */

    .table_foot {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;

      /deep/.el-pager li.active {
        color: #2ab18b;
      }

      /deep/ .el-pager li:hover {
        color: #2ab18b;
      }
    }
  }

  .boder_table {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  /deep/.has-gutter tr th {
    height: 75px;
    background: #f0f2f5;
    color: #909399;
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2ab18b;
    border-color: #2ab18b;
  }

  /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2ab18b !important;
    border-color: #2ab18b !important;
  }
}
</style>
<style >
.del_message_btn {
  background-color: #f56c6c !important;
  border-color: #f56c6c !important;
}

.only_course {
  background-color: #fff !important;
}

.only_course:hover {
  border-color: #409eff !important;
  color: #409eff !important;
}

.many_course {
  color: #606266 !important;
  background-color: #fff !important;
  border-color: #dcdfe6 !important;
}

.many_course:hover {
  background-color: #fff !important;
  border-color: #409eff !important;
  color: #409eff !important;
}
</style>
